export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[640px] md:min-h-[720px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20vibrant%20abstract%20artistic%20composition%20with%20coral%20red%20and%20warm%20amber%20gradients%2C%20soft%20overlapping%20circles%20and%20flowing%20curves%20inspired%20by%20comic%20art%20aesthetics%2C%20dark%20charcoal%20accents%2C%20modern%20minimalist%20style%2C%20no%20text%2C%20no%20characters%2C%20atmospheric%20and%20energetic%20mood%2C%20suitable%20for%20website%20hero%20background&width=1920&height=1080&seq=hero-bg-manga&orientation=landscape"
          alt="女神漫画背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 z-10">
        <div className="w-full flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12 xl:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left pt-8 md:pt-0">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-200 text-sm font-medium mb-5">
              全网热门漫画一站式阅读平台
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              女神漫画<span className="block md:inline"> · 免费韩漫日漫国漫</span>
            </h1>

            <p className="text-lg md:text-xl text-background-100/90 font-medium mb-6">
              每日更新 · 高清无删减 · 下拉式畅读
            </p>

            <p className="text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              女神漫画网官方首页，致力于为广大漫画爱好者提供海量优质漫画资源。覆盖韩漫、日漫、国漫全品类，支持下拉式在线阅读，无需下载即可畅享高清画质。站内每日同步更新热门连载，实时追踪最新话，搭配智能排行榜与个性化推荐，让你轻松发现心仪作品。无论你是追更党还是补番派，女神漫画都是你最佳的在线阅读伴侣。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">30,000+</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">海量漫画库</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">同步连载追踪</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">永久免费</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">无广告纯净阅读</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门排行
              </a>
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 border border-background-50/30 text-background-50 font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-book-open-line text-lg"></i>
                编辑精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] sm:w-[340px] sm:h-[460px] md:w-[400px] md:h-[540px] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20illustration%20of%20a%20stylized%20manga%20reading%20scene%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20abstract%20comic%20panel%20background%20with%20soft%20speech%20bubble%20shapes%2C%20elegant%20flowing%20lines%2C%20modern%20editorial%20style%2C%20no%20text%20no%20characters%2C%20artistic%20composition%20with%20dynamic%20energy%2C%20warm%20gradients%2C%20sophisticated%20design%20aesthetic&width=800&height=1080&seq=hero-manga-visual&orientation=portrait"
                alt="女神漫画 - 免费韩漫日漫国漫在线阅读平台主视觉"
                className="w-full h-full object-cover object-top rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}